import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import i18n from 'i18n';
import { getAllServersRequest } from 'modules/environments/actions';
import styles from './styles';

const useStyles = makeStyles(styles);

const ExampleSection = ({
  titleKey,
  descriptionKey,
  imageSrc,
  showExample,
  setShowExample,
}) => {
  const classes = useStyles();
  return (
    <Grid item>
      <Typography component="div" className={classes.howToOptimizeDescription}>
        <Box fontWeight="bold" display="inline">
          {`• ${i18n.t(titleKey)}: `}
        </Box>
        {i18n.t(descriptionKey)}
      </Typography>
      <Grid item onClick={() => setShowExample(!showExample)}>
        <Typography component="div" className={classes.howToOptimizeExample}>
          <Box fontWeight="bold" display="inline" className={classes.blueBox}>
            {i18n.t('SEE_EXAMPLE_KEY')}
          </Box>
          {showExample ? (
            <ExpandLessIcon className={classes.expandIcon} />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} />
          )}
        </Typography>
      </Grid>
      {showExample && (
        <img
          src={imageSrc}
          alt={descriptionKey}
          className={classes.imageExamples}
        />
      )}
    </Grid>
  );
};

const PublishExamples = () => {
  const classes = useStyles();
  const [showExamples, setShowExamples] = React.useState({
    default: false,
    keep: false,
    reconnection: false,
  });

  return (
    <>
      <Grid container>
        <Typography className={classes.howToOptimizeHeader}>
          {`${i18n.t('OPTIMIZED_PUBLICATION_DEFINITION_KEY')}:`}
        </Typography>
      </Grid>
      <Grid container>
        <ExampleSection
          titleKey="DEFAULT_KEY"
          descriptionKey="HOW_TO_OPTIMIZE_DEFAULT_KEY"
          imageSrc="/images/defaultPublish.png"
          showExample={showExamples.default}
          setShowExample={() =>
            setShowExamples({ ...showExamples, default: !showExamples.default })
          }
        />
        <ExampleSection
          titleKey="ENVIRONMENTS_PAGE.KEEP_USERS_CONNECTED_KEY"
          descriptionKey="HOW_TO_OPTIMIZE_KEEP_KEY"
          imageSrc="/images/keepPublish.png"
          showExample={showExamples.keep}
          setShowExample={() =>
            setShowExamples({ ...showExamples, keep: !showExamples.keep })
          }
        />
        <ExampleSection
          titleKey="ENVIRONMENTS_PAGE.REQUEST_USER_FEATURE_KEY"
          descriptionKey="HOW_TO_OPTIMIZE_RECONNECTION_KEY"
          imageSrc="/images/reconnectionPublish.png"
          showExample={showExamples.reconnection}
          setShowExample={() =>
            setShowExamples({
              ...showExamples,
              reconnection: !showExamples.reconnection,
            })
          }
        />
        <Grid item>
          <Typography
            component="div"
            className={classes.howToOptimizeDescription}
          >
            <Box fontWeight="bold" display="inline">
              {`• ${i18n.t('STOP_SERVER_KEY')}: `}
            </Box>
            {i18n.t('HOW_TO_OPTIMIZE_STOP_SERVER_KEY')}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default connect(null, { getAllServersRequest })(PublishExamples);
